/* tslint:disable */
/* eslint-disable */
export enum ChangeEffect {
  Instant = 'Instant',
  NextInterval = 'NextInterval'
}
